import React, { useEffect, useState, useRef } from 'react';
interface ParallaxSectionProps {
  children: React.ReactNode;
  speed?: number;
  className?: string;
}
export function ParallaxSection({
  children,
  speed = 0.5,
  className = ''
}: ParallaxSectionProps) {
  const [offsetY, setOffsetY] = useState(0);
  const sectionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const scrollProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      if (scrollProgress >= 0 && scrollProgress <= 1) {
        setOffsetY(scrollProgress * 100 * speed);
      }
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [speed]);
  return <div ref={sectionRef} className={className} data-id="element-100">
      <div style={{
      transform: `translateY(${offsetY}px)`
    }} className="transition-transform duration-100 ease-out" data-id="element-101">
        {children}
      </div>
    </div>;
}